import React from "react";
import SkeletonBlock from "../common/SkeletonBlock";
import CompletedActivityCardSkeleton from "../common/CompletedActivityCardSkeleton";

// Widths for the fitted-text labels inside each chooser button placeholder.
const CHOOSER_BUTTON_WIDTHS = ["w-2/5", "w-1/2", "w-1/3"];

/**
 * Loading placeholder for the questionnaire chooser route. Mirrors the real
 * layout: a stack of full-width purple `primary-button` links
 * (QuestionnaireChooser) above the grey completed-history panel
 * (QuestionnaireHistoryList). Purple tiles use the `light` shimmer tone so the
 * placeholder reads against the brand colour, matching the loaded state.
 */
export default function QuestionnairePageLoadingShell() {
  return (
    <div
      aria-busy="true"
      data-testid="questionnaire-page-skeleton"
      className="w-full max-w-lg min-h-full flex flex-col items-center gap-4"
    >
      <div className="w-full px-4">
        <div className="w-full flex flex-col items-center gap-3">
          <div className="w-full flex flex-col gap-3">
            {CHOOSER_BUTTON_WIDTHS.map((width, index) => (
              <div
                key={index}
                aria-hidden="true"
                className="primary-button pointer-events-none w-full"
              >
                <SkeletonBlock
                  tone="light"
                  className={`h-5 max-w-[12rem] rounded-full ${width}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="w-full flex flex-col gap-3 bg-greyscale-1 p-4 rounded-t-3xl">
        {Array.from({ length: 3 }, (_, index) => (
          <CompletedActivityCardSkeleton key={index} />
        ))}
      </section>
    </div>
  );
}
